module.exports = __webpack_public_path__ + "static/media/calendar-icon.c35b8b2b.svg";